import React, { useState, useEffect } from 'react';
import { arrayMove } from 'react-sortable-hoc';
import Modal from 'react-modal';
import { Grid, Button } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { showProgress } from '../../redux/actions/DealershipActions';
import 'react-toastify/dist/ReactToastify.css';
import { ErrorToast, notifySuccess } from '../utils/Utils';
import ReorderComponent from '../common/ReorderComponent';
toast.configure();

const ChangeOrderJourney = ({ title, open, data = [], handleClose, handleChange }) => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(open);
  const [list, setList] = useState({});

  useEffect(() => {
    setList(data);
  }, [data]);

  useEffect(() => {
    setShow(open);
  }, [open]);

  const closePopup = () => {
    setShow(false);
    handleClose();
  };

  const changeOrder = async () => {
    dispatch(showProgress(true));
    try {
      await handleChange(list);
      notifySuccess('Saved Successfully');
      dispatch(showProgress(false));
      closePopup();
    } catch (err) {
      closePopup();
      ErrorToast(err);
      dispatch(showProgress(false));
    }
  };

  const onSortEnd = ({ oldIndex, newIndex }) => {
    setList((l) => arrayMove(l, oldIndex, newIndex));
  };

  return (
    <Modal
      isOpen={show}
      onRequestClose={() => false}
      shouldCloseOnEsc={false}
      style={{
        overlay: { backgroundColor: 'hsla(50, 33%, 25%, 0.35)' },
        content: {
          display: 'flex',
          padding: '20px 16px 28px',
          width: '500px',
          height: '600px',
          background: '#FFFFFF',
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
        },
      }}
    >
      <Grid container direction="column">
        <Grid item>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
            style={{
              width: '443px',
              height: '82px',
              marginLeft: '16px',
              marginTop: '20px',
            }}
          >
            <Grid item>
              <Grid
                container
                direction="column"
                justifyContent="flex-start"
                alignItems="flex-start"
                style={{ width: '283px', height: '67px' }}
              >
                <Grid item>
                  <div
                    style={{
                      fontFamily: 'Montserrat',
                      fontStyle: 'normal',
                      fontWeight: '600',
                      fontSize: '18px',
                      lineHeight: '22px',
                      display: 'flex',
                      alignItems: 'center',
                      color: 'black',
                    }}
                  >
                    {' '}
                    {title}
                  </div>
                </Grid>
                <Grid item>
                  <div
                    style={{
                      fontFamily: 'Montserrat',
                      fontStyle: 'normal',
                      fontWeight: '500',
                      fontSize: '12px',
                      lineHeight: '15px',
                      color: 'rgba(0, 0, 0, 0.4)',
                    }}
                  >
                    Drag and drop to change order
                  </div>
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <CloseIcon style={{ cursor: 'pointer' }} onClick={closePopup} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item style={{ height: '72%', overflow: 'auto' }}>
          <ReorderComponent items={list} onSortEnd={onSortEnd} />
        </Grid>
        <Grid item style={{ position: 'absolute', bottom: '3%', marginLeft: '8%' }}>
          <Button
            variant="contained"
            disableElevation
            style={{
              width: '200px',
              height: '42px',
              fontFamily: 'Montserrat',
              fontStyle: 'normal',
              fontWeight: '600',
              fontSize: '14px',
              lineHeight: '17px',
              textAlign: 'center',
            }}
            onClick={closePopup}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={changeOrder}
            style={{
              width: '200px',
              height: '42px',
              marginLeft: '16px',
              fontFamily: 'Montserrat',
              fontStyle: 'normal',
              fontWeight: '600',
              fontSize: '14px',
              lineHeight: '17px',
              textAlign: 'center',
            }}
          >
            <div style={{ color: '#EB5757' }}>Change Order</div>
          </Button>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default ChangeOrderJourney;
